import { call, put, takeEvery } from "redux-saga/effects";
import {
  CATALOG_BUSINESS_TYPE,
  CATALOG_CONSTRUCTION_TYPE,
  CATALOG_PAYMENT_MODE,
  CATALOG_PLAN_REFERENCE,
  GET_CATALOG_ACCOUNT_TYPE,
  GET_CATALOG_BENEFICIARY,
  GET_CATALOG_BY_ID,
  GET_CATALOG_INSURANCE,
  GET_CATALOG_STATUS_QUOTE,
  GET_CATALOGS_TYPE,
  CATALOG_ACTION_TYPE,
  CATALOG_APPOINTMENT_STATUS
} from "./actionTypes";
import {
  getCatalogAccountTypeError,
  getCatalogAccountTypeSuccess,
  getCatalogBeneficiaryError,
  getCatalogBeneficiarySuccess,
  getCatalogBusinessError,
  getCatalogBusinessSuccess,
  getCatalogByIdError,
  getCatalogByIdSuccess,
  getCatalogConstructionError,
  getCatalogConstructionSuccess,
  getCatalogInsuranceError,
  getCatalogInsuranceSuccess,
  getCatalogPaymentModeError,
  getCatalogPaymentModeSuccess,
  getCatalogPlanReferenceError,
  getCatalogPlanReferenceSuccess,
  getCatalogStatusQuoteError,
  getCatalogStatusQuoteSuccess,
  getCatalogsTypeError,
  getCatalogsTypeSuccess,
  getCatalogActionTypeError,
  getCatalogActionTypeSuccess,
  getCatalogAppointmentStatusError,
  getCatalogAppointmentStatusSuccess,
} from "./actions";
import {
  getCatalogByIdApi,
  getCatalogsApi,
  getStatusQuoteCatalog,
} from "../../resources/helper/catalog";

function* getCatalogById({ payload: { getCatalogById } }) {
  try {
    const response = yield call(getCatalogByIdApi, getCatalogById.id);
    yield put(getCatalogByIdSuccess(response));
  } catch (error) {
    yield put(getCatalogByIdError(error));
  }
}

function* catalogStatusQuote({ payload: { catalogStatusQuote } }) {
  try {
    const response = yield call(
      getStatusQuoteCatalog,
      catalogStatusQuote.enable,
      catalogStatusQuote.page,
      catalogStatusQuote.limit,
    );
    yield put(getCatalogStatusQuoteSuccess(response));
  } catch (error) {
    yield put(getCatalogStatusQuoteError(error));
  }
}

function* getCatalogsType({ payload: { catalogsType } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogsType.enable,
      catalogsType.page,
      catalogsType.limit,
      catalogsType.type,
      catalogsType.clientId,
    );
    yield put(getCatalogsTypeSuccess(response));
  } catch (error) {
    yield put(getCatalogsTypeError(error));
  }
}

function* getCatalogPaymentMode({ payload: { catalogPaymentMode } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogPaymentMode.enable,
      catalogPaymentMode.page,
      catalogPaymentMode.limit,
      catalogPaymentMode.type,
      catalogPaymentMode.clientId,
    );
    yield put(getCatalogPaymentModeSuccess(response));
  } catch (error) {
    yield put(getCatalogPaymentModeError(error));
  }
}

function* getCatalogAccountType({ payload: { catalogAccountType } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogAccountType.enable,
      catalogAccountType.page,
      catalogAccountType.limit,
      catalogAccountType.type,
      catalogAccountType.clientId,
    );
    yield put(getCatalogAccountTypeSuccess(response));
  } catch (error) {
    yield put(getCatalogAccountTypeError(error));
  }
}

function* getCatalogBeneficiary({ payload: { catalogBeneficiary } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogBeneficiary.enable,
      catalogBeneficiary.page,
      catalogBeneficiary.limit,
      catalogBeneficiary.type,
      catalogBeneficiary.clientId,
    );
    yield put(getCatalogBeneficiarySuccess(response));
  } catch (error) {
    yield put(getCatalogBeneficiaryError(error));
  }
}

function* getCatalogInsurance({ payload: { catalogInsurance } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogInsurance.enable,
      catalogInsurance.page,
      catalogInsurance.limit,
      catalogInsurance.type,
      catalogInsurance.clientId,
      catalogInsurance.planId,
    );
    yield put(getCatalogInsuranceSuccess(response));
  } catch (error) {
    yield put(getCatalogInsuranceError(error));
  }
}

function* getCatalogBusiness({ payload: { catalogBusiness } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogBusiness.enable,
      catalogBusiness.page,
      catalogBusiness.limit,
      catalogBusiness.type,
    );
    yield put(getCatalogBusinessSuccess(response));
  } catch (error) {
    yield put(getCatalogBusinessError(error));
  }
}

function* getCatalogConstruction({ payload: { catalogConstruction } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogConstruction.enable,
      catalogConstruction.page,
      catalogConstruction.limit,
      catalogConstruction.type,
    );
    yield put(getCatalogConstructionSuccess(response));
  } catch (error) {
    yield put(getCatalogConstructionError(error));
  }
}

function* getCatalogActionType({ payload: { catalogActionType } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogActionType.enable,
      catalogActionType.page,
      catalogActionType.limit,
      catalogActionType.type,
      catalogActionType.clientId,
    );
    yield put(getCatalogActionTypeSuccess(response));
  } catch (error) {
    yield put(getCatalogActionTypeError(error));
  }
}

function* getCatalogAppointmentStatus({ payload: { catalogAppointmentStatus } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogAppointmentStatus.enable,
      catalogAppointmentStatus.page,
      catalogAppointmentStatus.limit,
      catalogAppointmentStatus.type,
      catalogAppointmentStatus.clientId,
    );
    yield put(getCatalogAppointmentStatusSuccess(response));
  } catch (error) {
    yield put(getCatalogAppointmentStatusError(error));
  }
}

function* CatalogSaga() {
  yield takeEvery(GET_CATALOG_BY_ID, getCatalogById);
  yield takeEvery(GET_CATALOG_STATUS_QUOTE, catalogStatusQuote);
  yield takeEvery(GET_CATALOGS_TYPE, getCatalogsType);
  yield takeEvery(CATALOG_PAYMENT_MODE, getCatalogPaymentMode);
  yield takeEvery(GET_CATALOG_ACCOUNT_TYPE, getCatalogAccountType);
  yield takeEvery(GET_CATALOG_BENEFICIARY, getCatalogBeneficiary);
  yield takeEvery(GET_CATALOG_INSURANCE, getCatalogInsurance);
  yield takeEvery(CATALOG_BUSINESS_TYPE, getCatalogBusiness);
  yield takeEvery(CATALOG_CONSTRUCTION_TYPE, getCatalogConstruction);
  yield takeEvery(CATALOG_PLAN_REFERENCE, getCatalogPlanReference);
  yield takeEvery(CATALOG_ACTION_TYPE, getCatalogActionType);
  yield takeEvery(CATALOG_APPOINTMENT_STATUS, getCatalogAppointmentStatus);
}

function* getCatalogPlanReference({ payload: { catalogPlanReference } }) {
  try {
    const response = yield call(
      getCatalogsApi,
      catalogPlanReference.enable,
      catalogPlanReference.page,
      catalogPlanReference.limit,
      catalogPlanReference.type,
      catalogPlanReference.clientId,
    );
    yield put(getCatalogPlanReferenceSuccess(response));
  } catch (error) {
    yield put(getCatalogPlanReferenceError(error));
  }
}

export default CatalogSaga;
